export default __webpack_public_path__ + "static/media/vajra_text_white.326407b2.png";